import FlightPassengerRenderField from './FlightPassengerRenderField'

export default FlightPassengerRenderField
